module.exports = ".input-group-text i {\n  transition: all 0.3s ease-out 0s; }\n"